import { SpecialEventValueTypes } from "../SpecialEventsQuery/SpecialEventsQuery.consts";
import { formatClickType } from "src/pages/Conversations/consts";

export const UserActionsOptions = {
  RESULT_CLICK: "RESULT_CLICK"
};

export const UserActionsAttributes = {
  [UserActionsOptions.RESULT_CLICK]: {
    type: "RESULT_CLICK",
    key: "clickType",
    label: "Click on results card",
    valueType: SpecialEventValueTypes.DROPDOWN,
    placeholder: "Select click type",
    supportsMultiSelect: true,
    formatOption: formatClickType
  }
};
